<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <h1 class="text-center title">Fiches d'animation de communautés d'apprentissage (CAP)</h1>
    <div class="page-containerp">
      <div class="page-area-new">
        <p>Les ressources ci-dessous comprennent des fiches pour animer une communauté d'apprentissage professionnelle (CAP). Celles-ci encouragent de bonnes pratiques ainsi que des questions de réflexion pour améliorer continuellement le parcours professionnel du personnel éducateur dans le domaine de la petite enfance.</p>
      </div>
    </div>
    <div class="page-containerp">
      <div class="page-area-new">
        <router-link class="row link" v-for="info in infos" :key="info.linkName" :to="{ name: info.linkName }">
          <div class="d-none d-md-block image-wrapper">
            <!-- .imageSrc .imageAlt -->
            <img :src="info.imageSrc" class="img-fluid corner-cutted" :alt="info.imageAlt" />
          </div>
          <div class="col d-flex align-items-center">
            <p class="h2">{{ info.titre }}</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
export default {
  components: {
    ProgressBars,
  },
  data() {
    return {
      infos: [
        {
          imageSrc: require("@/assets/fiches/cap1/AdobeStock_265794447.jpeg"),
          imageAlt: "",
          titre: "Bien-être",
          linkName: "AnimationSheet1",
        },
        {
          imageSrc: require("@/assets/fiches/cap2/AdobeStock_348345239.jpeg"),
          imageAlt: "",
          titre: "Expression",
          linkName: "AnimationSheet2",
        },
        {
          imageSrc: require("@/assets/fiches/cap3/AdobeStock_248470038.jpeg"),
          imageAlt: "",
          titre: "Appartenance",
          linkName: "AnimationSheet3",
        },
        {
          imageSrc: require("@/assets/fiches/cap4/AdobeStock_289101851.jpeg"),
          imageAlt: "",
          titre: "Engagement",
          linkName: "AnimationSheet4",
        },
      ],
    };
  },
};
</script>

<style scoped>
h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}
.h2 {
  font-size: 1.35rem !important;
  color: #000;
  font-weight: 600;
}
.page-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.page-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px 30px;
  margin-bottom: 20px;
}
.link {
  margin: 30px 0px;
  width: fit-content;
}
.link:hover p,
.link:focus p {
  text-decoration: underline;
}
@media (min-width: 1200px) {
  .link {
    width: 50%;
    display: inline-flex;
  }
}
.image-wrapper {
  width: 150px;
}
img.corner-cutted {
  border-radius: 15px;
}
</style>
